import React from 'react'
import classNames from 'classnames'
import H2 from './H2'

const PanelTitle = ({ className, ...props }) => (
  <H2 className={classNames('panel__title', className)} {...props} />
)

export default PanelTitle
